<template>
    <el-container>
        <el-header class="cate_mana_header">
            <el-input placeholder="请输入栏目名称" v-model="cateName" style="width: 200px;"></el-input>
            <el-button type="primary" size="medium" style="margin-left: 10px" @click="addNewCate">新增栏目</el-button>
        </el-header>
        <el-main class="cate_mana_main">
            <el-table ref="multipleTable" :data="categories" tooltip-effect="dark" style="width: 100%" v-loading="loading">
                <el-table-column label="序号" type="index" width="120" align="center"></el-table-column>
                <el-table-column label="栏目名称" prop="cateName" width="150" align="center" show-overflow-tooltip=""></el-table-column>
                <el-table-column prop="date" label="创建时间" align="center">
                    <template slot-scope="scope">{{ scope.row.date | formatDate }}</template>
                </el-table-column>
                <el-table-column label="操作" align="left">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
    </el-container>
</template>
<script>
import { postRequest, putRequest, deleteRequest, getRequest } from '@/utils/api';
import { addCategory, deleteCategpry, updateCategory, getCateAll } from '@/api';
export default {
    methods: {
        async addNewCate() {
            this.loading = true;
            try {
                const result = await addCategory({ cateName: this.cateName });
                if (result.status === 200) {
                    this.$message({ type: 'success', message: '添加成功' });
                    this.cateName = '';
                    this.refresh();
                } else {
                    this.$message({ type: 'error', message: '添加失败' });
                }
            } catch (error) {}
            this.loading = false;
        },

        handleEdit(index, row) {
            var _this = this;
            this.$prompt('请输入新名称', '编辑', {
                confirmButtonText: '更新',
                inputValue: row.cateName,
                cancelButtonText: '取消',
            }).then(async ({ value }) => {
                //value就是输入值
                if (value == null || value.length == 0) {
                    _this.$message({ type: 'info', message: '数据不能为空!' });
                } else {
                    _this.loading = true;
                    try {
                        const { status, data } = await updateCategory({ id: row.id, cateName: value });
                        console.log(result);
                        if (status === 200 && data.status === 'success') {
                            _this.$message({ type: 'success', message: '更新成功' });
                            _this.refresh();
                        } else {
                            _this.$message({ type: 'error', message: '更新失败' });
                        }
                    } catch (error) {}
                    _this.loading = false;
                }
            });
        },

        handleDelete(index, row) {
            let _this = this;
            this.$confirm('确认删除 ' + row.cateName + ' ?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                _this.deleteCate(row.id);
            });
        },

        async deleteCate(id) {
            this.loading = true;
            //删除
            try {
                const { status, data } = await deleteCategpry({ id });
                // console.log(result)
                if (status === 200 && data.status === 'success') {
                    this.$message({ type: 'success', message: '删除成功' });
                    this.refresh();
                } else {
                    this.$message({ type: 'error', message: '删除失败' });
                }
            } catch (error) {
                const { status, data } = error;
                if (data.status === 500) {
                    this.$message({ type: 'error', message: '该栏目下尚有文章，删除失败!' });
                }
                if (data.status === 403) {
                    // this.$message({ type: 'error', message: resp.response.data });
                }
            }
            this.loading = false;
        },
        async refresh() {
            this.loading = true;
            try {
                const { data, status } = await getCateAll();
                this.categories = data;
            } catch (error) {}
            this.loading = false;
        },
    },
    mounted: function() {
        this.loading = true;
        this.refresh();
    },
    data() {
        return {
            cateName: '',
            categories: [],
            loading: false,
        };
    },
};
</script>
<style>
.cate_mana_header {
    background-color: #ececec;
    margin-top: 20px;
    padding-left: 5px;
    display: flex;
    justify-content: flex-start;
}

.cate_mana_main {
    /*justify-content: flex-start;*/
    display: flex;
    flex-direction: column;
    padding-left: 5px;
    background-color: #ececec;
    margin-top: 20px;
    padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/article/CateMana.vue